import * as amplitude from '@amplitude/unified';

import runtimeEnv from '~/shared/utils/runtimeEnv';

let initialized = false;

/**
 * Initializes Amplitude analytics and Session Replay.
 *
 * The API key arrives through `window.__RUNTIME_ENV__` (see
 * `public/__RUNTIME_ENV__.js` for local dev and the `amplitudeApiKey` CDK
 * context value for deployed stages), so it can be rotated without a rebuild.
 * A stage without the key configured is a silent no-op otherwise, hence the
 * warning below.
 *
 * Safe to call more than once — only the first call initializes the SDK.
 */
export function initAmplitude(): void {
  if (initialized) return;

  const apiKey = runtimeEnv.amplitudeApiKey;
  if (!apiKey) {
    console.warn('Amplitude API key missing — analytics disabled');
    return;
  }

  initialized = true;

  amplitude.initAll(apiKey, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  });
}

export { amplitude };
